import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { downgradeComponent } from '@angular/upgrade/static';
import { ApiModule } from 'src/app/api';
import { CpfCnpjMaskPipeModule } from '../forms/cpf-cnpj-mask.pipe';
import { MdePopoverModule } from '@material-extended/mde';
import * as angular from 'angular';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ListingComponent } from './listing/listing.component';
import { ShippingReturnRoutingModule } from './shipping-return-routing.module';
import { ServicesModule } from '../services/services.module';

@NgModule({
  imports: [
    ApiModule,
    ShippingReturnRoutingModule,
    ServicesModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    CpfCnpjMaskPipeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MdePopoverModule,
    DashboardModule,
  ],
  declarations: [ListingComponent]
})
export class ShippingReturnModule { }

try {
  angular.module('mandaeApp')
    .directive('appShippingReturnListing', downgradeComponent({ component: ListingComponent }));
} catch (e) {}
